import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class AppRouteReuseStrategy implements RouteReuseStrategy {
  private storedHandles = new Map<string, DetachedRouteHandle>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const path = this.getRoutePath(route);
    return path.startsWith('dashboardss')
      || path.startsWith('store-mgt')
      || path.startsWith('user-mgt')
      || path.startsWith('service-mgt')
      || path.startsWith('service-mgt')
      || path.startsWith('notice-mgt')
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const path = this.getRoutePath(route);
    this.storedHandles.set(path, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const path = this.getRoutePath(route);
    return this.storedHandles.has(path);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const path = this.getRoutePath(route);
    return this.storedHandles.get(path) || null;
  }
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  private getRoutePath(route: ActivatedRouteSnapshot): string {
    let path = route.routeConfig?.path ?? '';
    let parent = route.parent;
    while (parent) {
      if (parent.routeConfig?.path) {
        path = `${parent.routeConfig.path}/${path}`;
      }
      parent = parent.parent;
    }
    return path;
  }

  public removeRouteSnapshot(path: string): void {
    this.storedHandles.delete(path);
  }

  public removeAllRouteSnapshots(): void {
    this.storedHandles.clear();
  }
}
